module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wallet"
    }
  }, [_c('div', {
    staticClass: "wallet",
    style: ('margin-top:' + _vm.playHeight + 'px')
  }, [_c('img', {
    attrs: {
      "src": _vm.imgPath + 'home/wallet.png'
    },
    on: {
      "click": _vm.showSalesList
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showSales),
      expression: "showSales"
    }],
    staticClass: "sales"
  }, [_c('div', {
    staticClass: "sales_musk"
  }), _vm._v(" "), _c('div', {
    staticClass: "sales_box"
  }, [_c('img', {
    staticClass: "bg",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/sales-bg.png"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "close",
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/home/close.png"
    },
    on: {
      "click": _vm.closeSales
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "tabs"
  }, [_c('div', {
    staticClass: "tabs_title"
  }, [_c('div', {
    staticClass: "btn",
    class: {
      cur: (_vm.curSale == 1)
    },
    on: {
      "click": function($event) {
        return _vm.changeCur(1)
      }
    }
  }, [_c('a', [_vm._v("我的动态")])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    class: {
      cur: (_vm.curSale == 2)
    },
    on: {
      "click": function($event) {
        return _vm.changeCur(2)
      }
    }
  }, [_c('a', [_vm._v("全部动态")])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curSale == 1),
      expression: "curSale == 1"
    }, {
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getSalesList),
      expression: "getSalesList"
    }],
    staticClass: "list",
    attrs: {
      "waterfall-disabled": "disabledSale",
      "waterfall-offset": "100"
    }
  }, [(_vm.salesList.length) ? _c('ul', _vm._l((_vm.salesList), function(item) {
    return _c('li', {
      staticClass: "ellipsis"
    }, [(item.share_fans_id == 0) ? [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 从你的链接购买了" + _vm._s(item.buy_num) + "件商品\n\t\t\t\t\t\t\t")] : [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 获得了"), _c('span', {
      staticClass: "pink"
    }, [_vm._v(_vm._s(item.money / 100) + "元")]), _vm._v("分享收益\n\t\t\t\t\t\t\t")]], 2)
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/nothing.png"
    }
  })])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.curSale == 2),
      expression: "curSale == 2"
    }, {
      name: "waterfall-lower",
      rawName: "v-waterfall-lower",
      value: (_vm.getSalesList2),
      expression: "getSalesList2"
    }],
    staticClass: "list",
    attrs: {
      "waterfall-disabled": "disabledSales",
      "waterfall-offset": "100"
    }
  }, [(_vm.salesLists.length) ? _c('ul', _vm._l((_vm.salesLists), function(item) {
    return _c('li', {
      staticClass: "ellipsis"
    }, [(item.share_fans_id == 0) ? [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 购买了" + _vm._s(item.buy_num) + "件商品\n\t\t\t\t\t\t\t")] : [_c('span', {
      staticClass: "orange"
    }, [_vm._v(_vm._s(item.nick))]), _vm._v(" 获得了"), _c('span', {
      staticClass: "pink"
    }, [_vm._v(_vm._s(item.money / 100) + "元")]), _vm._v("分享收益\n\t\t\t\t\t\t\t")]], 2)
  }), 0) : _c('div', {
    staticClass: "nothing"
  }, [_c('img', {
    attrs: {
      "src": "https://tengfaceliveuser.tengface.net/web/wx-user/wechatlive/img/nothing.png"
    }
  })])])])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0930e935"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Modular/salesList.vue
// module id = 357
// module chunks = 0